import clsx from 'clsx';
import React from 'react';
import { JustifyPosition, OptionListDirection } from "./option.vm";
import '@isyc-react/design/main';
export const OptionListContainer = props => {
  const {
    className,
    direction = OptionListDirection.HORIZONTAL,
    justify = JustifyPosition.START,
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('d-flex flex-wrap', {
      'justify-content-start': justify === JustifyPosition.START,
      'justify-content-center': justify === JustifyPosition.CENTER,
      'justify-content-end': justify === JustifyPosition.END,
      'flex-column': direction === OptionListDirection.VERTICAL,
      'align-items-center': direction !== OptionListDirection.VERTICAL
    }, className)
  }, children);
};